import * as React from 'react';
import { OrderSummarySection } from './order-summary-section';
import StaticData, { StaticDataGroup } from 'ted-ui/build/StaticData';
import { IOrderDetailsProps } from '@applications/order-tracker/config/order-tracker-new-common/types';
import { showOrderDetailsComponent,
    showSecReference,
    showTelstraProjectCode,
    showTelstraProjectCodeLegacy
 } from '@applications/order-tracker/config/order-tracker-new-common/order-products-utils';

export const OrderDetailsSection = ({orderSummary}: IOrderDetailsProps) => {
    const orderDetailsTitle = (orderSummary.telstraProjectCode ||
        ((orderSummary.isLegacy)
        && orderSummary.secondaryReference)) ? 'Order details' : '';
    const getGroupOfDescsOrderDetails = (): React.ReactNode => (
        <>
            <StaticData
                    helpText=""
                    id="static-data-test"
                    name="Telstra project code"
                    value={orderSummary.telstraProjectCode} />
            <StaticData
                    helpText=""
                    id="static-data-test"
                    name="Secondary reference"
                    value={orderSummary.secondaryReference} />
        </>
    );
    const getGroupOfDescsTelstraCode = (): React.ReactNode => (
        <><StaticData
            helpText=""
            id="static-data-test"
            name="Telstra project code"
            value={orderSummary.telstraProjectCode} />
        </>
    );
    const getGroupOfDescsSecReference = (): React.ReactNode => (
        <><StaticData
            helpText=""
            id="static-data-test"
            name="Secondary reference"
            value={orderSummary.secondaryReference} />
        </>
    );
    const getGroupOfDescs = (): React.ReactNode => (
        <StaticDataGroup id="order-details-group-data">
            {showOrderDetailsComponent(orderSummary) &&
                getGroupOfDescsOrderDetails()
            }
            {showSecReference(orderSummary) &&
                getGroupOfDescsSecReference()
            }
            {showTelstraProjectCodeLegacy(orderSummary) &&
                getGroupOfDescsTelstraCode()
            }
            {showTelstraProjectCode(orderSummary) &&
                getGroupOfDescsTelstraCode()
            }
        </StaticDataGroup>
    );
    return (
        <OrderSummarySection
            title={orderDetailsTitle}
            descriptionGroup={getGroupOfDescs()}
        />
    )
};
